'use client';

import AiGame from "../../projects/tba/AiGame";

export default function TriviaBattleArena() {
    return <AiGame />;
}
